module.exports = __webpack_public_path__ + "static/img/frontPage21.ffe5221a.jpg";